import axiosInstance from '../axiosInstance';

/**
 * Dashboard Notification Service
 * Notifications for managers & staff (read-only fan-out rows created by the API).
 */
const notificationService = {
  // Paginated list + unread count
  getNotifications: async (page = 1, limit = 30) => {
    try {
      const response = await axiosInstance.get(
        `/carehome-manager/notifications?page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error fetching notifications' };
    }
  },

  // Unread count only (cheap — used by the navbar bell badge)
  getUnreadCount: async () => {
    try {
      const response = await axiosInstance.get('/carehome-manager/notifications/unread-count');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error fetching unread count' };
    }
  },

  markRead: async (id) => {
    try {
      const response = await axiosInstance.patch(`/carehome-manager/notifications/${id}/read`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error marking notification read' };
    }
  },

  markAllRead: async () => {
    try {
      const response = await axiosInstance.patch('/carehome-manager/notifications/read-all');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Error marking all read' };
    }
  },
};

export default notificationService;
